import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TvfRequestsService } from '@app/tvf/services/tvf-requests.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-dialog-edit-trade-details',
  templateUrl: './dialog-edit-trade-details.component.html',
  styleUrls: ['./dialog-edit-trade-details.component.sass'],
})
export class DialogEditTradeDetailsComponent implements OnInit {
  form!: FormGroup;

  states!: { sigla: string; nome: string }[];
  idTrade!: string;
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<DialogEditTradeDetailsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      idTrade: string;
      company: any;
    },
    private tvfRequestsService: TvfRequestsService,
    private toastrService: ToastrService
  ) {}
  ngOnInit(): void {
    this.form = this.fb.group({
      portador: ['', Validators.required],
      agencia: ['', Validators.required],
      cashflowInstallment: ['', Validators.required],
    });

    this.fillForm();
  }

  fillForm() {
    if (!this.data?.company) return;
    this.idTrade = this.data.idTrade;
    const carrierPlot = this.parseArray(this.data.company.carrierPlot);
    const agencyCarrierPlot = this.parseArray(this.data.company.agencyCarrierPlot);
    const cashflowInstallmentPlot = this.parseArray(this.data.company.cashflowInstallment);

    this.form.patchValue({
      portador: carrierPlot[0] || '',
      agencia: agencyCarrierPlot[0] || '',
      cashflowInstallment: cashflowInstallmentPlot[0] || '',
    });
  }
  parseArray(value: any): string[] {
    if (!value) return [];

    try {
      let parsed = value;

      while (typeof parsed === 'string') {
        parsed = JSON.parse(parsed);
      }

      while (Array.isArray(parsed) && Array.isArray(parsed[0])) {
        parsed = parsed[0];
      }

      if (Array.isArray(parsed) && typeof parsed[0] === 'string') {
        try {
          const inner = JSON.parse(parsed[0]);
          if (Array.isArray(inner)) {
            parsed = inner;
          }
        } catch {}
      }

      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  updateCompany() {
    if (this.form.invalid) return;

    const payload = {
      carrierPlot: this.form.value.portador,
      agencyCarrierPlot: this.form.value.agencia,
      cashflowInstallment: this.form.value.cashflowInstallment,
    };
    this.tvfRequestsService.companyDetailsTrade(this.data.idTrade, payload).subscribe({
      next: () => {
        this.toastrService.success("Não se esqueça de também atualizar o cadastro de fluxo de caixa no SAV para que não ocorra erro com outros trades");
        this.dialogRef.close(true);
      },
      error: (response) => {
        const errorMsg = response.errors?.[0] ?? 'Não foi possível atualizar.';
        this.toastrService.error(errorMsg);
        this.dialogRef.close(false);
      },
    });
  }
  onCancel() {
    this.dialogRef.close(false);
  }
}
